import React from "react";

import { TitleH1 } from "../../styles/sharedStyles";
import { ButtonAnchor } from "../ButtonAnchor/ButtonAnchor";

import {
  Desc,
  Section,
} from "./styles"

type TInfoSection = {
  descText: string;
  backgroundImage: string;
  mainText: string;
  whiteText?: boolean;
  buttonTitle?: string;
}

export const ServiceBannerSection: React.FC<TInfoSection> = ({
  backgroundImage,
  mainText,
  descText,
  whiteText = false,
  buttonTitle = "Бесплатная консультация",
}) => {

  return (
    <Section bgImage={backgroundImage}>
      <TitleH1 style={whiteText ? { color: "#fff" } : undefined}>{mainText}</TitleH1>
      <Desc style={whiteText ? { color: "#fff" } : undefined}>{descText}</Desc>
      <ButtonAnchor
        href="https://t.me/ProhorovaConsult"
        title={buttonTitle}
      />
    </Section>
  );
};
